
$('.owl-carousel').owlCarousel({
    loop:true,
    dots:false,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:2,
            nav:true,
            loop:true
        },
        1000:{
            items:4,
            nav:true,
            loop:true
        }
    }
});
 $( ".owl-prev").html('<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 9.5L0.75 5L5.25 0.5" stroke="#6ABCB8" stroke-linecap="round" stroke-linejoin="round"/></svg>');
 $( ".owl-next").html('<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 9.5L5.25 5L0.75 0.5" stroke="#6ABCB8" stroke-linecap="round" stroke-linejoin="round"/></svg>');


$(function() {
  $('.header__submenu li').hover(function() {
      $(this).addClass('active').siblings().removeClass('active');
      $(this).find('details').attr('open', true);
      $(this).find('summary').attr('aria-expanded', true);
  }, function() {
      $('.header__submenu li').removeClass('active');
      $(this).find('details').attr('open', false);
      $(this).find('summary').attr('aria-expanded', false);
  });

var url_coll = window.location.href;
  var arr = url_coll.split('/'); 
  var myoutput = arr[4].split('?', 1)[0];
  //alert(myoutput);
   if(myoutput != undefined){
     $('ul.one_step .menu_handle').each(function(){
          var myarray = $(this).attr('data-sub');
          var strarray = myarray.split(',');
          for (var i = 0; i < strarray.length; i++) {
            var coll_handle = strarray[i];
             if(coll_handle == myoutput){
               //alert($(this).attr('data-title'));
              // $('.itg_collection_text').text($(this).attr('data-title'));
               $(this).addClass('sidebar_collection');
             }else{
               //$(this).hide();
             }
          }
     });
   }else{
     //$('.itg_collection_text').text('');
     $(this).hide();
   }
  
});



$(function() {
  $('.acc__title').click(function(j) {
    
    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();
    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.acc').find('.acc__title.active').removeClass('active');
      $(this).addClass('active');
    }
    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});


$(document).ready(function(){
  
  $("#iPhone").change(function () {
    var selectedValue = $.trim($(this).val());
    if(selectedValue != ''){
      $('#model_option').hide();
      $('#without_model_option').show();
      $(".itg_varint_none").find('label').each(function(){
       var sel_label = $.trim($(this).attr('data-label'));
       if(sel_label == selectedValue){
         $(this).trigger('click');
       }
      });
    }
  });
  $("#samsung").change(function () {
    var selectedValue = $.trim($(this).val());
    if(selectedValue != ''){
      $('#model_option').hide();
      $('#without_model_option').show();
      $(".itg_varint_none").find('label').each(function(){
       var sel_label = $.trim($(this).attr('data-label'));
       if(sel_label == selectedValue){
         $(this).trigger('click');
       }
      });
    }
  });
  $("#pixel").change(function () {
    var selectedValue = $.trim($(this).val());
    if(selectedValue != ''){
      $('#model_option').hide();
      $('#without_model_option').show();
      $(".itg_varint_none").find('label').each(function(){
       var sel_label = $.trim($(this).attr('data-label'));
       if(sel_label == selectedValue){
         $(this).trigger('click');
       }
      });
    }
  });
  $("#LG_option").change(function () {
    var selectedValue = $.trim($(this).val());
    if(selectedValue != ''){
      $('#model_option').hide();
      $('#without_model_option').show();
      $(".itg_varint_none").find('label').each(function(){
       var sel_label = $.trim($(this).attr('data-label'));
       if(sel_label == selectedValue){
         $(this).trigger('click');
       }
      });
    }
  });

  $(document).on("click","#model_option",function() {
     var iPhone_data = $('#iPhone').find(":selected").val();
     var samsung_data = $('#samsung').find(":selected").val();
     var pixel_data = $('#pixel').find(":selected").val();
     var lg_data = $('#LG_option').find(":selected").val();
     if(iPhone_data !='' || samsung_data !='' || pixel_data !='' || lg_data !=''){
        $('#model_option').hide();
        $('#without_model_option').show();
     }else{
        $('#model_option').show();
        $('#without_model_option').hide();
        alert('please select model');
        return false;
     }
  });
  
});





